import React from "react";

import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import roleTypesSettings from "./roleTypesSettings";
import getStringInitials from "../utils/getStringInitials";

const RoleReaderPreview = ({ hidden, roleTypes }) => {
  const nameList = roleTypes.map((r) => r.name);
  const list = nameList.filter(i => !hidden.includes(`role_type_${i}`))
  return (
    <div className="flex mr-2">
      {list?.length
        ? list
            //.filter((type) => roleTypesSettings[type])
            .map((type) => (
              <div
                style={{ marginRight: "-8px" }}
                key={type}
                className={`flex justify-center items-center w-7 h-7 rounded-full ${roleTypesSettings[type]?.color ?? 'bg-gray-400'}`}
              >
                <p className="text-white text-xs font-bold">
                  {roleTypesSettings[type]?.abbr ?? getStringInitials(type)}
                </p>
              </div>
            ))
        : null}
    </div>
  );
};

const ServiceConfiguratorActionsBox = ({
  hidden,
  roleTypes,
  open,
  setOpen,
  blockType,
}) => {
  return (
    <div className="flex items-center">
      <RoleReaderPreview hidden={hidden} roleTypes={roleTypes} />
      {blockType === "step" || blockType === "recursive_question" || blockType === "service" ? (
        <div className="w-7 h-7 cursor-pointer ml-2" onClick={() => setOpen(!open)}>
          {open ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </div>
      ) : null}
    </div>
  );
};

export default ServiceConfiguratorActionsBox;
